import React from 'react';
import styled from 'styled-components';
import TrueImpactCapsule from 'shared/design-system/components/TrueImpactCapsule';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';

export const impactSummaryTableGridStyles = `
  display: grid;
  gap: ${SPACERS.small};
  grid-template-columns: 1fr 1.5fr 1.5fr 1fr;
`;

const StyledDiv = styled.div`
  padding: 16px 36px;
  ${impactSummaryTableGridStyles}
  background-color: ${COLORS.grayLight};
`;

const ReportImpactSummaryHeader: React.FC = () => (
  <StyledDiv>
    <div>
      <TrueImpactCapsule
        variant="body-small-bold"
        backgroundColor="grayLightest"
      >
        STAGE
      </TrueImpactCapsule>
    </div>
    <div>
      <TrueImpactCapsule
        variant="body-small-bold"
        backgroundColor="grayLightest"
      >
        FORECAST
      </TrueImpactCapsule>
    </div>
    <div>
      <TrueImpactCapsule
        variant="body-small-bold"
        backgroundColor="grayLightest"
      >
        DATA QUALITY
      </TrueImpactCapsule>
    </div>
    <div style={{ justifySelf: 'center' }}>
      <TrueImpactCapsule
        variant="body-small-bold"
        backgroundColor="grayLightest"
      >
        VARIANCE
      </TrueImpactCapsule>
    </div>
  </StyledDiv>
);

export default ReportImpactSummaryHeader;
